<script lang="ts">
    import { _ } from 'svelte-i18n';

    export let label: string | null = null;
</script>

{#if label !== null}
    <span class="display-label dont-break" title={$_('label')} data-value={label}>
        {label.trim()}
    </span>
{/if}

<style>
    .display-label {
        font-style: italic;
        opacity: 0.6;
        font-weight: 200;
    }
</style>
